<template>
  <div>
    <ModalCover :show_close="false" modal_style="rounded-5 modal-small">
      <!-- MODAL BODY -->
      <div slot="modal-cover-body" class="add-student-modal">
        <!-- MODAL TOP -->
        <div class="container-fluid px-0">
          <div class="modal-title-row">
            <!-- TITLE -->
            <div class="title text-uppercase font-weight-bold color_text">
              Select Student
            </div>

            <!-- CLOSE DIALOG -->

            <div class="avatar pointer" @click="$emit('closeTriggered')">
              <span class="icon-decline flex-center font-20"></span>
            </div>
          </div>

          <!-- MODAL BODY -->
          <div class="filter-modal-body">
            <div class="form-input" v-if="false">
              <input
                type="search"
                class="form-control rounded-45 brand_white_bg"
                placeholder="Search student name.."
                @input="filterStudent"
                v-model="search"
              />
            </div>

            <!-- ADD ALL STUDENT -->
            <label
              for="selectAll"
              class="add-all pointer d-flex justify-content-between align-items-center nowrap"
            >
              <!-- LEFT -->
              <!-- <div
                class="left d-flex justify-content-start align-items-center nowrap"
              >
                <div class="avatar avatar-square brand_inverse_light_bg">
                  <span
                    class="icon-add-group flex-center font-22 brand_inverse"
                  ></span>
                </div>
                <div class="text color_text">Select All</div>
              </div> -->

              <!-- RIGHT -->
              <!-- <div class="right checkbox">
                <input
                  type="checkbox"
                  id="selectAll"
                  @change="selectAllStudent($event)"
                />
              </div> -->
            </label>

            <!-- STUDENT LIST -->
            <div
              class="student-list d-flex justify-content-between align-items-center nowrap mx-auto"
              v-for="(student, index) in student_list"
              :key="index"
            >
              <!-- LEFT -->
              <div
                class="left d-flex justify-content-start align-items-center nowrap"
              >
                <div class="avatar avatar-square brand_inverse_light_bg">
                  <!-- AVATAR IMG -->
                  <img
                    v-lazy="student.image"
                    :alt="student.firstname | getInitial"
                    class="avatar-img brand_inverse_light_bg border_brand_inverse"
                    v-if="student.image"
                  />
                  <!-- AVATAR TEXT -->
                  <div class="avatar-text white-text font-weight-bold" v-else>
                    {{
                      (student.firstname + " " + student.lastname) | getInitial
                    }}
                  </div>
                </div>

                <div class="text color_text">
                  {{ student.firstname + " " + student.lastname }}
                </div>
              </div>

              <!-- RIGHT -->
              <div class="right checkbox">
                <input
                  type="checkbox"
                  class="student-checkbox"
                  :class="'student' + student.id"
                  @change="selectStudent($event, student.id)"
                />
              </div>
            </div>
            <!-- STUDENT LIST -->
            <div
              class="submit-btn d-flex justify-content-center align-items-center"
            >
              <button
                type="button"
                @click="sendSelectedStudent"
                :disabled="isDisabled"
                class="btn btn-md btn-accent brand_navy font-weight-bold"
              >
                Add
              </button>
            </div>
            <!-- ADD ALL STUDENT -->
          </div>
        </div>
      </div>
    </ModalCover>
  </div>
</template>

<script>
import ModalCover from "@/components/globalComps/ModalCover";
import { setInitial } from "@/scripts/utilities";
import { setProfileBg } from "@/scripts/profile-colors";

export default {
  name: "AddStudentModal",

  components: {
    ModalCover,
  },

  props: {
    students: {
      type: Array,
    },
    selected: {
      type: Array,
    },
  },

  computed: {
    isDisabled() {
      if (this.selected_student.length) return false;
      else return true;
    },
  },

  mounted() {
    if (this.selected.length) {
      this.selected.map((student) => {
        this.selected_student.push(student);
        document.querySelector(`.student${student[0].id}`).checked = true;
      });
    }
  },

  data() {
    return {
      student_list: this.students,
      selected_student: [],
      search: null,
    };
  },

  filters: {
    getInitial(value) {
      return setInitial(value);
    },

    setAvatarBg(value) {
      return setProfileBg(value);
    },
  },

  methods: {
    filterStudent() {
      console.log(this.search);
      this.student_list.filter((student) => {
        student.firstname.includes(student);
      });
    },

    selectAllStudent($event) {
      if ($event.target.checked) {
        this.selected_student = [];
        this.student_list.map((student) => {
          this.selected_student.push(student);
        });
        let checkbox = document.querySelectorAll(".student-checkbox");
        checkbox.forEach((box) => (box.checked = true));
      } else this.unSelectAllStudent();

      console.log("selected all", this.selected_student);
    },

    unSelectAllStudent() {
      this.selected_student = [];
      let checkbox = document.querySelectorAll(".student-checkbox");
      checkbox.forEach((box) => (box.checked = false));
    },

    selectStudent($event, id) {
      if ($event.target.checked) {
        let selected = this.student_list.filter((student) => student.id === id);
        this.selected_student.push(selected);
      } else this.unSelectStudent(id);

      console.log("selected", this.selected_student);
    },

    unSelectStudent(id) {
      let student_index = this.selected_student.findIndex(
        (student) => student.id === id
      );
      this.selected_student.splice(student_index, 1);
    },

    sendSelectedStudent() {
      this.$bus.$emit("event-bus-student-selected-list", this.selected_student);
      this.$emit("studentSelectedList", this.selected_student);
      this.$emit("closeTriggered");
    },
  },
};
</script>

<style lang="scss" scoped>
.add-student-modal {
  .modal-title-row {
    @include flex_row_between_nowrap;
    padding: 24px 20px;

    .title {
      font-size: 15px;
      line-height: 22px;
    }

    .avatar {
      background: $brand_white;
      transition: all 0.3s ease-in-out;

      &:hover {
        background: $brand_inverse_light;
      }

      span {
        color: $color_text;
        opacity: 0.6;
      }
    }
  }

  .filter-modal-body {
    padding-bottom: 20px;
    .form-input {
      padding: 2px 20px;
      margin-bottom: 10px;
      input {
        padding-left: 20px;
      }
    }

    .add-all,
    .student-list {
      padding: 2px 20px;
      margin-bottom: 10px;
      .avatar {
        @include equal_min_edge(36);
        margin-right: 10px;
      }

      .text {
        font-size: 14px;
        line-height: 19px;
      }

      input {
        position: relative;
        top: 5px;
      }
    }

    .student-list {
      padding: 10px 20px;
      margin-bottom: 1px;
      border-top: 1px solid $border_grey;
    }
  }
}
</style>
